import queryString from 'query-string'
import { isEmpty, isNil } from 'lodash'

import { apiService, fetchingAPI } from '@/api'

const VERIFIED_ANSWERS = () => `${apiService.agentGpt}/verified_answers`

// agent-gpt spells "every playbook" as null and refuses an empty list.
const playbookScope = (configCids) => (isEmpty(configCids) ? null : configCids)

// One page holds every answer while agent-gpt's per-org cap (VERIFIED_ANSWER_MAX_PAIRS)
// stays within its 500 page-size maximum.
const PAGE_SIZE = 500

// The composer shows agent-gpt's own messages, so skip the generic error toast.
const DETAILS = { isSilent: true }

export const fetchVerifiedAnswers =
  ({ organizationId }) =>
  async (dispatch) =>
    fetchingAPI(
      `${VERIFIED_ANSWERS()}?${queryString.stringify({
        page_size: PAGE_SIZE,
        requested_organization_id: organizationId,
      })}`,
      'GET',
      dispatch,
      undefined,
      undefined,
      DETAILS
    )

export const createVerifiedAnswer =
  ({ organizationId, question, answer, configCids, sourceAgentQuestionIds }) =>
  async (dispatch) =>
    fetchingAPI(
      `${VERIFIED_ANSWERS()}?${queryString.stringify({ requested_organization_id: organizationId })}`,
      'POST',
      dispatch,
      JSON.stringify({
        question,
        answer,
        config_cids: playbookScope(configCids),
        source_agent_question_ids: sourceAgentQuestionIds,
      }),
      undefined,
      DETAILS
    )

export const updateVerifiedAnswer =
  ({ organizationId, answerId, answer, configCids, sourceAgentQuestionIds }) =>
  async (dispatch) =>
    fetchingAPI(
      `${VERIFIED_ANSWERS()}/${answerId}?${queryString.stringify({ requested_organization_id: organizationId })}`,
      'PATCH',
      dispatch,
      // Omitted, agent-gpt leaves the answer, scope and links as it holds them.
      JSON.stringify({
        ...(isNil(answer) ? {} : { answer }),
        ...(isNil(configCids) ? {} : { config_cids: playbookScope(configCids) }),
        ...(isEmpty(sourceAgentQuestionIds)
          ? {}
          : { source_agent_question_ids: sourceAgentQuestionIds }),
      }),
      undefined,
      DETAILS
    )

export const deleteVerifiedAnswer =
  ({ organizationId, answerId }) =>
  async (dispatch) =>
    fetchingAPI(
      `${VERIFIED_ANSWERS()}/${answerId}?${queryString.stringify({ requested_organization_id: organizationId })}`,
      'DELETE',
      dispatch,
      undefined,
      undefined,
      DETAILS
    )

export const fetchVerifiedAnswerRevisions =
  ({ organizationId, answerId }) =>
  async (dispatch) =>
    fetchingAPI(
      `${VERIFIED_ANSWERS()}/${answerId}/revisions?${queryString.stringify({ requested_organization_id: organizationId })}`,
      'GET',
      dispatch,
      undefined,
      undefined,
      DETAILS
    )

// The org's playbooks as select options. Kept out of the shared analytics slice, which the
// page's upload card fills for whichever org it uploads to.
export const fetchPlaybookOptions =
  ({ organizationId }) =>
  async (dispatch) => {
    const playbooks = await fetchingAPI(
      `${apiService.core}/api/${organizationId}/configs?${queryString.stringify({
        requested_properties: 'id,name,cid',
      })}`,
      'GET',
      dispatch,
      undefined,
      undefined,
      DETAILS
    )

    return playbooks
      .map((playbook) => ({ value: playbook.cid, label: playbook.name }))
      .sort((first, second) => first.label.localeCompare(second.label))
  }
